<div class="db-ecommerce-tax-main__content-header">
    <div>
        <h1 *ngIf="!connectTaxesEnabled">{{ 'text_taxation' | dbText }} <span class="label ml8">{{ 'text_manual' | dbText }}</span></h1>
        <div class="mt4" *ngIf="!connectTaxesEnabled">
          <p>
                <span [innerHTML]="'text_chooseTaxSettings' | dbText"></span>
                <a *ngIf="!!taxPlugin?.installed && !!taxPlugin?.active && !!hasConnectTaxesOption"
                   class="ds-btn-l ds-btn-outline-gray"
                   [ngClass]="{'ds-btn-disabled': !!loading}"
                   (click)="showSwitchingDialog(true)">
                    <span *ngIf="!loading">{{ 'text_switchToAutomatedTaxRates' | dbText }}</span>
                    <db-loading-circular-spinner *ngIf="loading" [color]="'dark'"></db-loading-circular-spinner>
                </a>

                <a *ngIf="!!taxPlugin?.installed && !!taxPlugin?.active && !hasConnectTaxesOption"
                   class="ds-btn-l ds-btn-outline-gray"
                   [ngClass]="{'ds-btn-disabled': !!loading || !!enableBtnLoading}"
                   dbWpLink [adminLink]="website?.adminEcommerceUrls['tax']"
                   [websiteId]="website?.id" target="_blank" rel="noopener">
                  <span *ngIf="!loading && !enableBtnLoading">{{ 'text_connect' | dbText }}</span>
                  <db-loading-circular-spinner *ngIf="!!loading || !!enableBtnLoading" [color]="'dark'"></db-loading-circular-spinner>
                </a>

                <a *ngIf="(!taxPlugin || !taxPlugin?.active) && !hasConnectTaxesOption"
                   class="ds-btn-l ds-btn-outline-gray"
                   [ngClass]="{'ds-btn-disabled': !!enableBtnLoading}"
                   (click)="installAndActivateTax('yes')">
                  <span *ngIf="!enableBtnLoading">{{ 'text_enableAutomatedRates' | dbText }}</span>
                  <db-loading-circular-spinner *ngIf="enableBtnLoading" [color]="'dark'"></db-loading-circular-spinner>
                </a>
          </p>
        </div>
        <div class="db-ecommerce-tax-main__content-header-active" *ngIf="!!connectTaxesEnabled && !!hasConnectTaxesOption">
          <div>
            <h1>{{ 'text_taxation' | dbText }} <span class="label ml8">{{ 'text_automation' | dbText }}</span></h1>
            <p class="mt4">{{ 'text_theAutomatedTaxRates' | dbText }}</p>
          </div>
          <div>
            <a class="ds-btn-l ds-btn-outline-gray"
               [ngClass]="{'ds-btn-disabled': !!loading}"
               (click)="showSwitchingDialog(false)">
              <span *ngIf="!loading">{{ 'text_switchToManual' | dbText }}</span>
              <db-loading-circular-spinner *ngIf="loading" [color]="'dark'"></db-loading-circular-spinner>
            </a>
          </div>
        </div>
        <div class="db-ecommerce-tax-main__automation-list mt20" *ngIf="!!connectTaxesEnabled">
          <p>
            <i class=”db-icon db-icon-ds-checkmark-small”></i>
            <span>{{ 'text_yourTaxRatesAreNow' | dbText }}</span>
          </p>
          <p class=”mt8”>
            <i class=”db-icon db-icon-ds-checkmark-small”></i>
            <span>{{ 'text_automatedTaxesUseYourStoreAddress' | dbText }}</span>
          </p>
          <p class=”mt8”>
            <i class=”db-icon db-icon-ds-checkmark-small”></i>
            <span>{{ 'text_inAdditionToAutomatedRates' | dbText }}</span>
          </p>
          <p class="learn_more mt8 ml25">{{'text_learnMore' | dbText}}</p>
        </div>
    </div>
</div>
<div class="db-ecommerce-tax-main-table mt30" >
    <db-ecommerce-tax-rate-table [website]="website"></db-ecommerce-tax-rate-table>
    <db-ecommerce-tax-price-options [website]="website"></db-ecommerce-tax-price-options>
</div>
